module.exports = __webpack_public_path__ + "img/do.05db6325.png";